import {DeliveryType} from './delivery-type';


export interface ProductChange {
  id: string;
  title: string;
  teaser: string[];
  documentId: string;
  changeCategories: string[];
  deliveryDate: Date;
  dataTransformation: boolean;
  bootRequired: boolean ;
  deliveryBases: string[];
  deliveryId: string;
  deliveryName: string;
  deliveryType: DeliveryType | null;
  productKey: string;
  deliveredByRdt: boolean;
  deliveredByDownload: boolean;
  onlineProduct: boolean;
}

export class ProductChangeCategory {
  public static readonly values = {
    statutoryLowerCase: 'gesetzliche änderungen',
    functionalLowerCase: 'funktionale änderungen',
    bugfixLowerCase: 'fehlerbehebungen',
    technicalLowerCase: 'technische änderungen'
  };
  public static readonly order = [
    ProductChangeCategory.values.statutoryLowerCase,
    ProductChangeCategory.values.functionalLowerCase,
    ProductChangeCategory.values.bugfixLowerCase,
    ProductChangeCategory.values.technicalLowerCase
  ];
}
